import { useTranslation as originalUseTranslation } from 'react-i18next';

export const useCustomTranslation = (namespace?: string) => {
  const { t: originalT, ...rest } = originalUseTranslation();

  const t = (i18nKey: string, options?: any) => {
    // Modify the key before passing it to the original t function
    const modifiedKey: string = `${namespace ? `${namespace}.` : ''}${i18nKey}`;

    return originalT(modifiedKey, options);
  };

  return { t, ...rest };
};
